/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import api from '../services/Api';

import Translate from '../i18n/Translate';

import FeaturedItems from './FeaturedItems';
import FeaturedLoader from './loaders/FeaturedLoader';

const Featured = ({ setLoadingSlide2 }) => {
  const [featuredItem, setFeaturedItems] = useState({
    loading: true,
    data: {
      status: true,
      result: [],
      message: '',
    },
    error: null,
  });

  const getData = async () => {
    setFeaturedItems({
      ...featuredItem,
      loading: true,
      error: null,
    });

    try {
      const data = await api.images.featured();
      setFeaturedItems({
        loading: false,
        data,
      });
      setLoadingSlide2(false);
    } catch (error) {
      setFeaturedItems({
        loading: false,
        error,
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (featuredItem.loading === true) {
    return <FeaturedLoader />;
  }

  return (
    <>
      {featuredItem.data.status === true && featuredItem.data.result?.length && (
        <section className='featured sladio' id='slider2'>
          <h2>
            <Translate langkey='featured.title' />
          </h2>
          <div className='sladio__container featured__container'>
            {featuredItem.data.result?.map((item) => {
              return <FeaturedItems item={item} key={item.id} />;
            })}
          </div>
        </section>
      )}
    </>
  );
};

export default Featured;
